import { render, staticRenderFns } from "./AdminViewAssignTagOnAccountSDData.vue?vue&type=template&id=03dae728&scoped=true"
import script from "./AdminViewAssignTagOnAccountSDData.vue?vue&type=script&lang=js"
export * from "./AdminViewAssignTagOnAccountSDData.vue?vue&type=script&lang=js"
import style0 from "./AdminViewAssignTagOnAccountSDData.vue?vue&type=style&index=0&id=03dae728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dae728",
  null
  
)

export default component.exports